
<onwac-modal 
class="edit-user-modal"
[title]="'EDITPROFILE.editProfile' | translate" 
[show]="show"
(callback)="getModalResult($event)">
<div slot="content">
	<form [formGroup]="editUserForm" *ngIf="!show_password_form && editUserForm">
        <div class="form-group file d-flex justify-content-center">
          <div class="user-avatar" [style.background]="'url(' + userAvatar + ')'">
            <div class="icon pencil"></div>
			<input #file type="file" accept='image/*' (change)="getPreview(file.files)">
          </div>
        </div>

		<div class="form-group">
			<onwac-input 
			[type]="'text'" 
			[label]="'FORMS.fields.nameAndSurname' | translate"
			[input_name]="'username'"
			[submitted]="submitted"
			[parentForm]="editUserForm"
			[validators_feedback]="[
				{name : 'required', value : 'FORMS.validators.required' | translate }
			]"></onwac-input>
		</div>

		<div class="form-group">
			<onwac-input 
			[type]="'email'" 
			[label]="'FORMS.fields.email' | translate"
			[input_name]="'email'"
			[submitted]="submitted"
			[parentForm]="editUserForm"
			[validators_feedback]="[
				{ name : 'required', value : 'FORMS.validators.required' | translate },
				{ name : 'email', value : 'FORMS.validators.email' | translate }
			]"></onwac-input>
		</div>

		<div class="form-group">
			<p class="small text-center"><a class="link" (click)="showPasswordForm()">{{'EDITPROFILE.wantToChangePassword' | translate}}</a></p>
		</div>

		<div class="form-group submit d-flex justify-content-around align-items-center">
			<onwac-button [text]="'EDITPROFILE.cancel' | translate" [type]="'text'" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="close()"></onwac-button>
          	<onwac-button [text]="'EDITPROFILE.update' | translate" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="onSubmit()"></onwac-button>
		</div>
	</form>
	<form [formGroup]="editPasswordForm" *ngIf="show_password_form && editPasswordForm">
        <div class="form-group">
			<onwac-input 
			[type]="'password'" 
			[label]="'FORMS.fields.currentPassword' | translate"
			[input_name]="'old_password'"
			[submitted]="submittedPassword"
			[parentForm]="editPasswordForm"
			></onwac-input>
        </div>
        
        <div class="form-group">
			<onwac-input 
			[type]="'password'" 
			[label]="'FORMS.fields.newPassword' | translate"
			[input_name]="'new_password'"
			[submitted]="submittedPassword"
			[parentForm]="editPasswordForm"
			[validators_feedback]="[
              { name : 'required', value : 'FORMS.validators.required' | translate },
              { name : 'minlength', value : 'FORMS.validators.PasswordMinLength' | translate:{'x':'7'} }
            ]"></onwac-input>
        </div>
        
        <div class="form-group">
			<onwac-input 
			[type]="'password'" 
			[label]="'FORMS.fields.repeatPassword' | translate"
			[input_name]="'new_password_repeat'"
			[submitted]="submittedPassword"
			[parentForm]="editPasswordForm"
			[validators_feedback]="[
				{ name : 'required', value : 'FORMS.validators.required' | translate },
				{ name : 'mustMatch', value : 'FORMS.validators.mustMatch' | translate:{'x':'FORMS.fields.newPassword' | translate, 'y':'FORMS.fields.repeatPassword' | translate}}]"
			></onwac-input>
		</div>

		<div class="form-group submit d-flex justify-content-around align-items-center">
			<onwac-button [text]="'VOLVER'" [type]="'text'" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="closePasswordForm()"></onwac-button>
          	<onwac-button [text]="'ACTUALIZAR'" [size]="'large'" [extra_clases]="'block'" class="w-100" (click)="onSubmitPassword()"></onwac-button>
		</div>
	</form>
</div>
</onwac-modal>